'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var objectToCamel = require('./lib/object-to-camel.js');
var configure = require('./lib/configure.js');
var toUrlSearchParams = require('./lib/to-url-search-params.js');

const createMount = configure.configure(api => {
  async function mount(options = {}) {
    const res = await api.post('dns', {
      signal: options.signal,
      searchParams: toUrlSearchParams.toUrlSearchParams(options),
      headers: options.headers
    });
    return objectToCamel.objectToCamel(await res.json());
  }
  return mount;
});

exports.createMount = createMount;
